module.exports = __webpack_public_path__ + "static/media/Babybox_teal.562aebfc.png";